import React from "react";
import {ModalContext} from "@/modal/ModalHooks.ts";
import {useModalController} from "@/modal/useModalController.ts";

export function ModalProvider({children}: { children: React.ReactNode }) {
    const value = useModalController();
    return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}
